import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import {
  shortData,
} from '../../helpers';
import CustomTable from '../../components/CustomTable/CustomTable';
import { RowAction, RowActions } from '../../components/RowActions/RowActions';

const columns = [
  {
    id: 'Id', label: 'Id',
  },
  {
    id: 'SubscriberName', label: 'Subscriber Name',
  },
  {
    id: 'Type', label: 'Type',
  },
  {
    id: 'MobileNumber',
    label: 'Mobile Number',
  },
  {
    id: 'Email',
    label: 'Email',
  },
  {
    id: 'GeotaggingRadius',
    label: 'Geotagging Radius',
  },
  {
    id: 'AllowProgresswoPlan',
    label: 'Allow Progress w/o Plan',
  },
  {
    id: 'action',
    label: 'Action',
  },
];

const useStyles = () => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  tablewo: {
    cursor: 'pointer',
    '&:hover': {
      background: '#eeeeee',
    },
  },
  mainContainer: {
    // The page container (components/PageContainer) owns padding and width.
    width: '100%',
    minWidth: 0,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    margin: 20,
  },
  buttonLink: {
    width: 20,
    height: 20,
    margin: 0,
    padding: 10,
  },
});

class table extends Component {
  render() {
    const {
      classes, handleShowEditForm, handleDeleteData, data,
      handleChangePage, handleChangeRowsPerPage, handleShowAddForm,
    } = this.props;

    return (
      <div className={classes.mainContainer}>
        <CustomTable
          icons={[{ icon: AddCircleOutlineRoundedIcon, name: 'Add Subscriber' }]}
          tableName='Subscribers'
          onIconClick={(key) => {
            handleShowAddForm && handleShowAddForm(key);
          }}
          tableHead={columns}
          itemComponent={data.length > 0 ? data.map((element, index) => (
            <TableRow
              className={classes.tablewo}
              tabIndex={-1}
              key={element.id}
              // onClick={(key) => { handleViewLoanDetails(key, element.id); }}
            >
              <TableCell>
                {index + 1}
              </TableCell>
              <TableCell>
                {shortData(element.subscriberName || '')}
              </TableCell>
              <TableCell>
                {shortData(element.subscriberType || '')}
              </TableCell>
              <TableCell>
                {shortData(element.mobile || '')}
              </TableCell>
              <TableCell>
                {shortData(element.email || '')}
              </TableCell>
              <TableCell>
                {element.mapCircleRadius || ''}
              </TableCell>
              <TableCell>
                {element.isMediaSubmissionAllowedWithoutConsPlan === 'true' ? 'True' : 'False'}
              </TableCell>
              <TableCell>
                <RowActions>
                  <RowAction
                    kind='edit'
                    onClick={(key) => { handleShowEditForm && handleShowEditForm(key, element); }}
                  />
                  <RowAction
                    kind='delete'
                    onClick={(key) => { handleDeleteData && handleDeleteData(key, element.id); }}
                  />
                </RowActions>
              </TableCell>
            </TableRow>
          )) : null}
          count={1}
          rowsPerPage={0}
          page={1}
          handleChangePage={handleChangePage && handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage && handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

export default withStyles(useStyles)(table);
